import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type DeleteImageV1WorkspacesWorkspaceIdAssetsImagesImageIdDeleteData,
  type DeleteImageV1WorkspacesWorkspaceIdAssetsImagesImageIdDeleteError,
  type DeleteImageV1WorkspacesWorkspaceIdAssetsImagesImageIdDeleteResponse,
  deleteImageV1WorkspacesWorkspaceIdAssetsImagesImageIdDelete,
} from '../../generated';

export type DeleteAssetImageMutationVariables = DeleteImageV1WorkspacesWorkspaceIdAssetsImagesImageIdDeleteData['path'];

export type DeleteAssetImageMutation = DeleteImageV1WorkspacesWorkspaceIdAssetsImagesImageIdDeleteResponse;

export const useDeleteAssetImageMutation = <
  TError = DeleteImageV1WorkspacesWorkspaceIdAssetsImagesImageIdDeleteError,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<DeleteAssetImageMutation, TError, DeleteAssetImageMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<DeleteAssetImageMutation, TError, DeleteAssetImageMutationVariables, TContext>({
    mutationKey: ['DeleteAssetImage'],
    mutationFn: async ({ workspace_id, image_id }: DeleteAssetImageMutationVariables) => {
      const { data } = await deleteImageV1WorkspacesWorkspaceIdAssetsImagesImageIdDelete({
        path: { workspace_id, image_id },
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useDeleteAssetImageMutation.fetcher = (
  { workspace_id, image_id }: DeleteAssetImageMutationVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await deleteImageV1WorkspacesWorkspaceIdAssetsImagesImageIdDelete({
      path: { workspace_id, image_id },
      throwOnError: true,
    });
    return data;
  };
};
